module.exports = __webpack_public_path__ + "static/projekty-etykiet-gg-brewery-9da09941e9b6fc2e5f9d85af71b03fd9.jpg";